invHdApp.config(['$translateProvider', function ($translateProvider) {
    $translateProvider.translations('tr', {
        // login.html
        'LOGIN_TITLE': 'Giriş Yap',
        'EMAIL_LOGIN_PLCHLDR': 'E-Posta Adresiniz...',
        'PASS_LOGIN_PLCHLDR': 'Şifreniz...',
        'REMEMBER_ME': 'Beni Hatırla',
        'LOGIN': 'Giriş Yap',

        // forgot.html
        'FORGOT_PASS': 'Şifremi Unuttum',
        'PASS_RESET_TITLE': 'Şifremi Sıfırla',
        'PASS_RESET_CONTENT': 'Lütfen giriş yaparken kullandığınız mail adresiniz giriniz.',
        'RESET_PASS_BTN': 'Sıfırla',

        // password.html
        'PASSWORD_TITLE': 'Yeni Şifre',
        'PASS_REPEAT_PLCHLDR': 'Şifre Tekrar...',
        'PASS_FORM_BTN': 'Sıfırla',

        'MAP': 'Harita',
        'ROUTES': 'Rotalar',
        'ORDERS': 'İşler',
        'OFFERS': 'Teklifler',
        'PRODUCTS': 'Ürünler',
        'SUPPORT': 'Destek',
        'DRIVERS': 'Ekip',
        'EARNING': 'Odemeler',
        'PARTNERS': 'Müşteriler',
        'LOCATIONS': 'Alıcı Müşteriler',
        'LOCATION_DETAIL': 'Alıcı Müşteri Detayları',
        'NEIGHBORHOOD': 'Mahalle',
        'PARTNER_TYPE': 'Müşteri Türü',
        'INVOICES': 'Faturalar',
        'STATIONS': 'Şubeler',
        'REPORTS': 'Raporlar',
        'SETTINGS': 'Ayarlar',
        'LOGOUT': 'Çıkış Yap',
        'BILLING': 'Faturalar',
        'FEEDBACK': 'Geri Bildirim',
        'ACCOUNT_INACTIVE': 'Hesabınız aktif değildir.',
        'ACCOUNT_INCORRECT_INFO': 'Bilgileriniz hatalıdır.',

        'PARTNER': 'Müşteri',
        'SELECT_PARTNER': 'Müşteri Seç',
        'ADD_NEW_PARTNER': 'Müşteri Ekle',
        'SELECT_COMPANY': 'Tedarikçi Seç',
        'BY_COMPANY': 'Tedarikçiye göre',
        'PARTNER_NAME': 'Müşteri Adı',
        'PARTNER_DETAIL': 'Müşteri Detayları',
        'PARTNER_REPORT': 'Müşteri Raporları',
        'NEW_PARTNER': 'Yeni Müşteri',
        'PARTNER_NOT_FOUND': 'Müşteri Bulunamadı',

        'ORDER_ID': 'İş No',
        'PRODUCT_DETAILS': 'Ürün Detayları',
        'FULL_NAME': 'Adı',
        'PHONE': 'Telefon Numarası',
        'STREET_ADDRESS': 'Açık Adres',
        'APARTMENT_BUILDIN': 'Bina No',
        'APARTMENT_NUMBER': 'Daire No',
        'SPECIAL_INST': 'Ek Açıklamalar',
        'DELIVERY_TYPE': 'Taşıma Türü',
        'DELIVERY_DATE': 'Taşıma Tarihi',
        'WEIGHT': 'Desi',
        'PIECE': 'Parça',
        'ADD_MORE': 'Paket Ekle',
        'REMOVE_BOX': 'Paketi Kaldır',
        'IMPORT_ORDER_EXCEL': 'Excel ile İş Yükle',
        'FLEXIBLE_DATE': 'Esnek Tarih',
        'CITY': 'İl',
        'STATE': 'İlçe',
        'SELECT_AREA': 'Bölge Seç',
        'SELECT_STATE': 'İlçe Seç',
        'SELECT_CITY': 'İl Seç',
        'SELECT_DISTRICTS': 'İlçe Seç',
        'ADD_DISTRICT': 'İlçe Ekle',
        'REMOVE_DISTRICT': 'Kaldır',

        'CREATED_AT': 'Oluşturulma Tarihi',
        'CREATED_ORDERS': 'Oluşturulan İşler',
        'CREATED': 'Oluşturuldu',
        'STARTED': 'Başladı',
        'CREATE': 'Oluştur',
        'ORDER_CREATED_SUCCESS': 'İş oluşturuldu',
        'COMPLETED_AT': 'Teslim Trh.',

        'COMPLETED': 'Tamamlandı',
        'WAITING': 'Bekliyor',
        'NUMBER_OF_PIECE': 'Paket Sayısı',

        'ORDER_STATUS': 'İş Durumu',
        'NOTE_NOT_FOUND': 'Not Bulunamadı',
        'WRITE_NOTE': 'Not Ekle',
        'NO_ACTIVITY': 'Hareket Bulunamadı',
        'ROUTE_ACTIVITY': 'Rota Hareketleri',
        'ORDER_ACTIVITY': 'İş Hareketleri',
        'ORDER_MOVE': 'İş Hareket Merkezi',
        'ACTIVITY': 'Hareketler',
        'NOTES': 'Notlar',
        'NO_DETAILS': 'Detay Bulunamadı',
        'DETAILS': 'Detaylar',

        'ON_DELIVERY_ORDERS': 'Devam Eden İşler',
        'TOTAL_ORDERS': 'Toplam İş',
        'COMPLETED_ORDERS': 'Tamamlanan İşler',
        'REFUND_ORDERS': 'Göndericiye Teslim Edilen İşler',
        'SHOW_COMPLETED_ORDERS': 'Tamamlanan İşlerı Göster',
        'UNSUCCESS_ORDERS': 'Başarısız İşler',
        'CANCELLED_ORDERS': 'İptal Edilen İşler',
        'DELIVERY_ORDERS': 'Teslimat İşleri (Adet)',
        'COLLECTION_ORDERS': 'Alım İşleri (Adet)',
        'FAST_ORDERS': 'Hızlı Teslimat',
        'DELIVERY_TIME': 'Teslimat Tarihi',
        'DELIVERY': 'Teslimat Tarihi',
        'NO_ORDERS': 'İş Bulunamadı',
        'NO_ROUTE': 'Rota Bulunamadı',
        'NO_ORDER': 'İş Bulunamadı',
        'NO_INVOICE': 'Fatura Bulunamadı',
        'PRINT_ORDERS': 'Yazdır',
        'ASSIGN_ORDERS_TO_CUSTOMER': 'İşleri Tedarikçiye Gönder',
        'ASSIGN_ORDERS_TO_ROUTE': 'İşleri Rotaya Ata',
        'SELECT_WORKER': 'Kurye Seç',
        'ASSIGN_ORDERS_TO_WORKER': 'İşleri Kuryeye Ata',
        'CHANGE_BUlK_STATUS': 'İşlerin Durumunu Değiştir',
        'ORDERS': 'İşler',
        'APP_STATUS': 'App Durum',
        'WORKER_LAST_ACTION': 'Kurye Son Aktiflik',
        'BY_WORKER': 'Kurye Ara',
        'BY_PLATE': 'Plaka ile Ara',
        'ADD_ORDER': 'İş Ekle',

        'NUMBER_PLATE': 'Plaka',
        'SELECT_PLATE': 'Plaka Seç',
        
        'SAAS_COMPANY': 'Tedarikçi',

        'CHANGE_PASSWORD': 'Şifre Değiştir',
        'OLD_PASSWORD': 'Eski Şifre',
        'NEW_PASSWORD': 'Yeni Şifre',
        'COMPANY_INFO': 'Gönderici Bilgileri',
        'COMPANY_INFO_DESC': '* vereceğiniz bu numara müşteriler tarafından maskelenmiş numara ile aranabilir.',
        'SUBJECT': 'Konu',
        'PRIORTY': 'Oncelik',

        'LOW': 'Düşük',
        'MIDDLE': 'Orta',
        'HIGH': 'Yüksek',
        'SEND': 'Gönder',
        'FEEDBACK_SUCCESSFULL_SEND': 'Geri bildiriminiz alınmıştır, teşekkür ederiz',

        'DRIVER_DETAIL': 'Kurye Detayları',
        'VEHICLE_TYPE': 'Araç Türü',
        'VEHICLE_YEAR': 'Araç Model Yılı',
        'VEHICLE_MAKE': 'Araç Modeli',
        'VEHICLE_MODEL': 'Araç Markası',
        'SELECT_VEHICLE': 'Araç Seç',
        'VEHICLE_INFO': 'Araç Bilgileri',
        'VEHICLE': 'Araç',

        'STOPS': 'Durak Sayısı',

        'START_TIME': 'Başlangıç Zamanı',
        'END_TIME': 'Bitiş Zamanı',
        'TOTAL_TIME': 'Toplam Zaman',
        'SERVICE_TIME': 'Servis Süresi',
        'STOP_TIME': 'Servis Süresi',
        'TIME': 'Süre',
        'DISTANCE': 'Mesafe',
        'MILE': 'Km',
        'NOT_ASSIGNED': 'Atanmadı',
        'EDIT_ROUTES': 'Rota Düzenleme Modu',
        'CLOSE_EDIT_ROUTES': 'Düzenleme Modunu Kapat',
        'PLEASE_SELECT_ORDER': 'Lütfen İş seçiniz.',
        'PCS': 'Adet',

        'DRIVER_NOT_FOUND': 'Kurye Bulunamadı',
        'SELECT_DRIVER': 'Kurye Seç',
        'DRIVER_REPORT': 'Kurye Raporları',
        'ADD_DRIVER': 'Kurye Ekle',
        'ASSIGN_TO_DRIVER': 'Atama Yap',
        'ASSIGN': 'Atama Yap',
        'EDIT_DRIVER': 'Kuryeyi Düzenle',
        'NOTE_FROM_DRIVER': 'Kurye Notu',
        'DRIVER_INFO': 'Kurye Bilgileri',
        'DRIVER': 'Kurye',
        'ASSIGN_ORDER_RT': 'İşleri Rotaya Ata',
        'NOT_ASSIGN': 'Atama Yapılmadı',

        'SELECT_STATUS': 'Durum Seç',
        'CHANGE_STATUS': 'Durum Değiştir',
        'DELIVERY_STATUS': 'Teslim Durumu',
        'ROUTE_STATUS': 'Rota Durumu',
        'CHANGE_ROUTE_STATUS': 'Rota Durumunu Değiştir',
        'ARRIVED_STATUS': 'Varış Durumu',
        'VERIFY_STATUS': 'Okutma Durumu',
        'STATUS': 'Durum',

        'STATION': 'Şube',
        'EXIT_STATION': 'Çıkış Şubesi',
        'SELECT_EXIT_STATION': 'Çıkış Şubesi Seç',
        'SELECT_STATION': 'Şube Seç',
        'EDIT_STATION': 'Şube Düzenle',
        'NEW_STATION': 'Yeni Şube',
        'STATION_CODE': 'Şube Adı',
        'STATION_NOT_FOUND': 'Şube Bulunamadı',
        'STATION_LABEL': 'Şube No',
        'STATION_ADDRESS': 'Şube Adresi',

        'TICKET': 'Destek Talebi',
        'SELECT_TICKET': 'Destek Talebi Seç',
        'EDIT_TICKET': 'Destek Talebi Düzenle',
        'NEW_TICKET': 'Destek Talebi Oluştur',
        'TICKET_CODE': 'Destek Talebi Adı',
        'TICKET_NOT_FOUND': 'Destek Talebi Bulunamadı',
        'TICKET_LABEL': 'Destek Talebi No',
        'TICKET_ADDRESS': 'Destek Talebi Adresi',
        'CREATED_DATE': 'Oluşturma Tarihi',
        'USER': 'Oluşturan Kişi',
        'COMPANY_CUSTOMER': 'Gönderici',
        'COMPANY': 'Tedarikçi',
        'DETAIL': 'Detaylar',
        'BY_TICKET_STATUS': 'Durum',
        'BY_CATEGORY': 'Ana Problem',
        'BY_ID': 'ID',
        'CLOSE_TICKET': 'Kapat',

        // Filters
        'BY_STATION': 'Şubeye Göre',
        'BY_EXIT_STATION': 'Çıkış Şube',
        'BY_DRIVER': 'Kuryeye Göre',
        'BY_CUSTOMER': 'Alıcıya Göre',
        'BY_PARTNER': 'İsmine Göre',
        'BY_ORDER_ID': 'İş Numarası',
        'BY_ORDER_PAYMENT': 'Tahsilat Türü',
        'BY_DELIVERY_DATE': 'Taşıma Tarihi',
        'BY_STATUS': 'İş Durumuna Göre',
        'BY_STATUS_NORMAL': 'Durumu',
        'BY_TYPE': 'İş Türüne Göre',
        'BY_ACTIVITY_TYPE': 'Hareket Türü',
        'BY_QR_CODE': 'QR Kod',
        'BY_DATE': 'Tarih',
        'BY_PRICE': 'Fiyat',
        'BY_INVOICE_ID': 'Fatura Numarası',
        'BY_NAME': 'İsim',
        'CLEAR_FILTER': 'Filtreyi Temizle',
        'BY_RT_NUMBER': 'Rota Numarası',
        'BY_CITY': 'İle Göre',
        'BY_DISTRICT': 'İlçeye Göre',
        'BY_NEIGHBOURDHOOD': 'Mahalleye Göre',
        'SEARCH_CONV': 'Konuşmalarda Ara',

        'ADDRESS_INFO': 'Adres Bilgileri',
        'ADDRESS': 'Adres',
        'TOTAL_ORDER': 'Toplam İş',
        'CUSTOMER_DBA': 'Marka Adı',
        'AUTHORIZED_NAME': 'Yetkili Adı',
        'SEND_PUSH': 'Push Notification Gönder',
        'SEND_SMS': 'Sms Gönder',
        'SEND_MAIL': 'Mail Gönder',
        'SEND': 'Gönder',
        'DRAG_LOGO': 'Logoyu Sürükle',
        'ADD_IMAGE': 'Görsel Ekle',
        'DRAG_FILE': 'Dosyayı Sürükle',
        'SELECT_FILE': 'Dosya Seç',
        'OR': 'Yada',
        'SELECT_ALL': 'Hepsini Seç',
        'SELECT_ALL_THIS_PAGE': 'Bu Sayfadakileri Seç',
        'SELECT_TYPE': 'Tür Seç',
        'SELECT_WEHICLE': 'Araç Seç',
        'SELECT_STATIONS': 'Şubeleri Seçiniz',
        'PLEASE_SELECT': 'Seçim Yapınız',
        'SELECT': 'Seçim Yap',

        'PHONE_NUMBER': 'Telefon Numarası',
        'NUMBER_OF_PIECE': 'Parça Sayısı',
        'NEW_ORDER': 'Yeni İş',
        'NEW_ROUTE': 'Yeni Rota',
        'NEW_DRIVER': 'Yeni Kurye',
        'NEW_STATION': 'Yeni Şube',
        'SEND_ORDERS_TO_MOVE': 'İşleri Hareket Merkezine Gönder',
        'TOTAL_RECORD': 'Toplam Kayıt',

        'PRINT': 'Yazdır',
        'PRINT_PDF': 'Pdf olarak Yazdır',
        'EDIT': 'Düzenle',
        'NEW': 'Yeni Ekle',
        'UPDATE': 'Güncelle',
        'CANCEL': 'İptal',
        'ARE_U_SURE_DELETE': 'Silmek istediğinize emin misiniz ?',
        'DELETE': 'Sil',

        'OKEY': 'Tamam',
        'ACTION': 'İşlemler',
        'COMPANY_NAME': 'Gönderici Adı',
        'ADDRESS': 'Adres',
        'FILTER': 'Filtrele',
        'APPLY_FILTER': 'Filtreyi Uygula',
        'CLEAR_FILTER': 'Filtreyi Temizle',
        'EXCEL_EXPORT': 'Dışa Aktar',
        'COMPANY_TYPE': 'Gönderici Türü',
        'CURRENT_PAGE': 'Sayfa',
        'TOTAL_PAGE': 'Toplam Sayfa',
        'BACK': 'Geri',
        'PREV': 'İleri',
        'ADD': 'Ekle',
        'CREATE': 'Oluştur',
        'TRANSACTIONS': 'İşlemler',
        'CREATED_AT': 'Veri Giriş Tarihi',
        'DETAILS': 'Detaylar',
        'WARNING': 'Dikkat!',
        'CLOSE': 'Kapat',
        'CONTINUE': 'Devam Et',
        'WILL_YOU_CONTINUE': 'Devam etmek istiyor musunuz ?',

        'TODAY': 'Bugün',
        'YESTERDAY': 'Dün',
        'LAST_7_DAYS': 'Son 7 Gün',
        'LAST_30_DAYS': 'Son 30 Gün',
        'THIS_MONTH': 'Bu Ay',
        'LAST_MONTH': 'Geçen Ay',
        'CUSTOM_RANGE': 'Ozel Aralık',
        'DONE': 'Bitti',
        'FROM': 'dan',

        'TYPE': 'Tür',
        'DELIVERED_BY': 'Teslim Eden Kişi',
        'DELIVERED_AT': 'Teslim Tarihi',
        'DELIVERED_TO': 'Teslim Alan Kişi',
        'NOT_DELIVERED_TO': 'Teslim Edilmeme Sebebi',
        'NOT_DELIVERED_AT': 'İşlem Tarihi',
        'SIGNATURE': 'İmza',
        'IMAGE': 'Resim',
        'BY': 'Tarafından',
        'ROUTE_ID': 'Rota ID',
        'EXPIRED_DATE': 'Bitiş Tarihi',
        'DATE': 'Tarih',
        'GO_TO_ORDER': 'İşe Git',
        'READ_ALL_PICKUP': 'Hepsini Teslim Alındı',
        'RECEIVER': 'Alıcı Müşteri',
        'EARNING_NOT_FOUND': 'Odeme Bulunamadı',

        'DONT_ACCOUNT': 'Henüz hesabınız yok mu ?',
        'GET_START': 'Hemen Kayıt Ol!',

        'PRODUCT_ID': 'Ürün No',
        'SALE_COUNT': 'Satış Sayısı',
        'PRICE_COUNT': 'Fiyat Sayısı',
        'NO_PRODUCT': 'Ürün bulunamadı',
        'PRODUCT_PRICES': 'Fiyatlar',
        'PRICE': 'Fiyat',
        'ADD_PRICE': 'Fiyat Ekle',
        'REMOVE_PRICE': 'Fiyat Kaldır',
        'PRODUCT_SAVED': 'Ürün Eklendi',
        'PRODUCT_UPDATED': 'Ürün Güncellendi',
        'PRODUCT_DELETED': 'Ürün Silindi',
        'NAME': 'İsim',
        'DESCRIPTION': 'Açıklama',
        'CREATE': 'Kaydet',
        'PRICE_NOT_FOUND': 'Fiyat Bulunamadı',
        'PRODUCT_DETAIL': 'Ürün Detayları',
        'ID': 'No',
        'UNSELECT': 'Seçimi Kaldır',
        'MESSAGE': 'Mesaj',

        'QTY': 'Adet',
        'PAID': 'Odenen Tutar',
        'NOT_PAID': 'Bekleyen',
        'BALANCE_DUE': 'Kalan Tutar',
        'TOTAL_TIP': 'Toplam Bahşiş',
        'TOTAL': 'Toplam',
        'INVOICE_DETAIL': 'Fatura Detayları',
        'INVOICE_ID': 'Fatura No',
        'NO_INVOICE': 'Fatura bulunamadı',
        'INVOICE_REPORT': 'Fatura Raporları',
        'MONEY_UNIT': '₺',
        'OPEN': 'Açık',
        'TAX': 'Vergi',
        'PRICE_RATE': 'Birim Başı Fiyat',
        'PAID_SUCCESS': 'Odendi',
        'ADD_PAYMENT': 'Odeme Ekle',
        'PAYMENTS': 'Odemeler',
        'DEBT': 'Borç',
        'CREDIT': 'Alacak',

        'MY_PROFILE': 'Kullanıcı Bilgilerim',
        'USER_INFO': 'Kullanıci Bilgileri',
        'FIRST_NAME': 'Adı',
        'LAST_NAME': 'Soyadı',
        'PASSWORD': 'Şifre',
        'PERMISSION': 'İzinler',
        'USERS': 'Kullanıcılar',

        'ORDER_REPORT': 'İş Raporları',
        'EARNING_REPORT': 'Kurye Odeme Raporları',
        'NUMBER_OF_ROUTE': 'Rota Sayısı',

        'EARNING_DETAIL': 'Kurye Odeme Detayları',
        'EARNING_ID': 'Odeme No',

        'STARTED_AT': 'Başlama Zamanı',
        'ENDED_AT': 'Bitiş Zamanı',

        'CUSTOMER_NAME': 'Müşteri Adı',
        'PRICE_PER_ORDER': 'İş Başı Fiyat',

        'MIN_WEIGHT': 'Min. Desi',
        'MAX_WEIGHT': 'Max. Desi',
        'PRICING': 'Fiyatlandırma',
        'ADD_PRICE': 'Fiyat Ekle',
        'REMOVE_PRICE': 'Fiyat Kaldır',

        'STATION_DISTRICT_INFO': 'Şubea yetkili ilçeleri şeçiniz',
        'ADD_DISTRICT': 'İlçe Ekle',
        'DISTRICTS': 'İlçeler',
        'CODE': 'Kod',

        'STATION_CREATED': 'Şube oluşturuldu.',
        'STATION_UPDATED': 'Şube güncelledi.',
        'STATION_DELETED': 'Şube silindi.',

        'EXPORT_EXCEL': 'Excel\'e Aktar',
        'REPORTS': 'Raporlar',
        'REPORT': 'Rapor',
        'COMPANY_NAME': 'Gönderici Adı',
        'DBA_INFO': '* Marka adı SMS\'ler, Telefon numarasıda Destek Telefonu olarak kullanılacaktır.',
        'COMPANY_INFO_UPDATED': 'Gönderici bilgileriniz güncellenmiştir',

        'PROOF': 'Teslimat Bilgileri',

        'YES': 'Evet',
        'NO': 'Hayır',
        'YES_PAY': 'Karşı Ödeme',
        'NO_PAY': 'Peşin Ödeme',
        'NO_MONEY': 'Bedelsiz',
        'DISPATCHER': 'Sevkiyat Yetkisi',
        'DISPATCH_STATIONS': 'Yekili Şubeler',
        'DEVICE': 'Cihaz',
        'DOCUMENTS': 'Dokümanlar',

        'APPROVE': 'Onayla',
        'REMOVE_APPROVE': 'Onayı Kaldır',
        'SWITCH_ONLINE': 'Online Yap',
        'SWITCH_OFFLINE': 'Offline Yap',

        'WAIT_APPROVE': 'Onay Bekliyor',
        'APPROVED': 'Onaylandı',

        'DONE': 'Tamam',
        'PRICE_PER_ORDER': 'İş Başı Ücret',
        'NOTES': 'Notlar',
        'DELIVERY_PAYMENT_TYPE': 'Tahsilatlı Gönderi',
        'RECEIVER_TYPE': 'Alıcı Türü',
        'RECEIVER_TYPE_INDIVIDUAL': 'Bireysel',
        'RECEIVER_TYPE_CORPORATE': 'Kurumsal',
        'DELIVERY_PAYMENT_PRICE': 'Tahsilat Tutarı',
        'SELECT_NEIGHBOURHOOD': 'Mahalle Seç',
        'NEIGHBOURHOOD': 'Mahalle', 
        'SELECT_DISTRICT': 'İlçe Seç',
        'SELECT_CITY': 'İl Seç',

        'PLATES': 'Plakalar',
        'PLATE_CODE': 'Plaka Kodu',
        'STATUS': 'Durum',
        'ACTIVE': 'Aktif',
        'INACTIVE': 'Pasif',
        'PLATES_NOT_FOUND': 'Plaka Bulunamadı',
        'NEW_PLATE': 'Yeni Plaka',
        'EDIT_PLATE': 'Plaka Düzenle',

        'AUTHORITY_STATIONS': 'Yetkili Olduğu Şubeler',
        'COLLECTION': 'KO Tahsilat',
        'TOTAL_COLLECTION': 'Toplam KO',
        'KO': 'Odeme Durumu',
        'KO_TYPE': 'Odeme Türü',
        'KO_PRICE': 'Kapıda Odeme ',
        'KO_NO': 'Odendi',
        'WORK_TYPE': 'İş Türü',

        'NO_COLLECTION': 'Kapıdan Odeme Tahsilatı Bulunamadı',
        'PAYMENT_NOT_FOUND': 'Odeme Bulunamadı',
        'COLLECTION_REPORT': 'Kapıdan Odeme Raporları',

        'BARCODE': 'Barkod',
        'WORKER': 'Kurye',
        'ORDER_PRICE': 'İş Ücreti',
        'SUPPLIER_PRICE': 'Tedarikçi Ücreti',
        'NO_NOTIFICATION': 'Not bulunamadı',

        'MOVEMENT_TYPE': 'Hareket Türü',
        'DOWNLOAD_VEHICLE': 'Araçtan İndir',
        'INSTALL_VEHICLE': 'Araca Yükle',
        'LOAD_STATION': 'Şube hattına Yükle',
        'CHECK_ORDER': 'Teyit okutması yap',
        'ORDER_ID_OR_SPECIAL': 'İş No veya Entegre Kod',

        'PAYMENT_INFO': 'Odeme Bilgileri',
        'ACCOUNT_HOLDER_NAME': 'Hesap Sahibi Adı',
        'IBAN': 'IBAN',

        'ARE_YOU_SURE_DELETE': 'Silmek istediğinize emin misiniz ?',

        'ONLINE_PAYMENT_ORDER': 'Kapıdan Odeme',
        'OFFLINE_PAYMENT_ORDER': 'Odendi',

        'ORDER_PAYMENT': 'Ödeme Türü',

        'FINANCE': 'Finans',
        'TAX_NUMBER': 'Vergi Numarası',
        'COMPANY_ADDRESS': 'Adresi',
        'COMPANY_DOCUMENT': 'Vergi Levhası',

        'DAILY_ROUTE_COUNT': 'Günlük açılacak rota sayısı',
        'ROUTE_MOVE': 'Rota İş Ekleme',
        'ROUTE': 'Rota',
        'SELECT_ROUTE': 'Rota Seç',
        'SPECIAL_TRACKING_NUMBER': 'Entegrasyon Kodu',
        'ORDER_SOURCE': 'İş Veri Kaynağı',
        'SMS_EMAIL_PERMISSION': 'Sms-Email İzni',
        'SEND_SMS': 'Sms Gönder',
        'SEND_EMAIL': 'E-Mail Gönder',
        'ALL_ORDERS': 'Pasif İşler',
        'NOTES_ORDERS': 'Notlu İşler',
        'ALL_REAL_ORDERS': 'Aktif İşler',
        'BY_TERM': 'İş Ara',
        'CARGO_DATE': 'İş Tarihi',
        'SELECT_DATE_TYPE': 'Tarih Türü',
        'SCHEDULED_TIME_TYPE': 'Teslimat Trh. ile',
        'SCHEDULED_TIME': 'Teslimat Tarihi',
        'CREATED_AT_TYPE': 'Kayıt Trh. ile',
        'CARGO_DATE_TYPE': 'İş Trh. ile',
        'COMPLETED_AT_TYPE': 'Teslim Trh. ile',
        'CITY_STATE': 'İl-İlçe',
        'INTEGRATION_NUMBER': 'Ent. No :',

        'TRANSFER_NOT_FOUND': 'Transfer Merkezi Bulunamadı',
        'TRANSFER_CREATED': 'Transfer Merkezi oluşturuldu.',
        'TRANSFER_UPDATED': 'Transfer Merkezi güncelledi.',
        'TRANSFER_DELETED': 'Transfer Merkezi silindi.',
        'BY_TRANSFER': 'Transfer Merkezi Ara',
        'NEW_TRANSFER': 'Yeni Ekle',
        'NEW_TRANSFER': 'Transfer Merkezi Ekle',
        'EDIT_TRANSFER': 'Transfer Merkezi Bilgileri Düzenle',
        'TRANSFER_CENTERS': 'Transfer Merkezleri',
        'SELECT_TRANSFER': 'Transfer Merkezi Seç',
        'TRANSFER': 'Transfer Merkezi',

        'BY_SHIPMENT_AREA': 'Dağıtım Bölgesi Ara',
        'NEW_SHIPMENT_AREA': 'Yeni Dağıtım Bölgesi',
        'EDIT_SHIPMENT_AREA': 'Dağıtım Bölgesi Düzenle',
        'SHIPMENT_AREA': 'Dağıtım Bölgeleri',
        'SHIPMENT_AREA_NOT_FOUND': 'Dağıtım Bölgesi Bulunamadı',
        'SHIPMENT_AREA_CREATED': 'Dağıtım Bölgesi oluşturuldu.',
        'SHIPMENT_AREA_UPDATED': 'Dağıtım Bölgesi güncelledi.',
        'SHIPMENT_AREA_DELETED': 'Dağıtım Bölgesi silindi.',

        'FAIL_ORDER': 'Teslim Edilemeyen İşler',
        'NO_FAIL_ORDER': 'Teslim Edilemeyen İş Bulunamadı',
        'FAIL_ORDER_SAVED': 'Kaydedildi',
        'FAIL_ORDER_UPDATED': 'Güncellendi',
        'FAIL_ORDER_DELETED': 'Silindi',
        'ORDER_COUNT': 'İş Sayısı',
        'PRINT_STATUS': 'Yazdırılma Durumu',
        'RETURN_LIST': 'Listeye Dön',
        'FAIL_ORDER_WARNING': 'Dikkat bu listede Tamamlanamadı durumu dışında duruma sahip İşler vardır. Devam etmek istiyor musunuz ? ',

        'TRANSFER_ORDER': 'Devreden İşler',
        'TRANSFER_DATE': 'Devir Tarihi',
        'TRANSFER_WORKER': 'Devir Kurye',
        'TRANSFER_PCS': 'Devir İş',

        'RETURN_ORDER': 'İade Edilen İşler',
        'RETURN_ORDER_ID': 'İade Edilen İş',
        'NO_RETURN_ORDER': 'İade Edilen İş Bulunamadı',
        'RETURN_ORDER_SAVED': 'Kaydedildi',
        'RETURN_ORDER_UPDATED': 'Güncellendi',
        'RETURN_ORDER_DELETED': 'Silindi',
        'RETURN_ORDER_WARNING': 'Dikkat bu listede Tamamlanamadı durumu dışında duruma sahip İşler vardır. Devam etmek istiyor musunuz ? ',

        'WORKER_STATION': 'Kurye Şubesi',
        'DOCUMENTS': 'Dokümanlar',
        'ADD_DOCUMENT': 'Doküman Ekle',
        'DOCUMENT_TYPE': 'Doküman Türü',
        'DOCUMENT_NOT_FOUND': 'Doküman Bulunamadı',
        'SHOW': 'Göster',

        'DELETE_ORDER_PERMISSION': 'İş Silme',
        'SHOW_ROUTE_PERMISSION': 'Rota Listesini Görüntüleme',
        'SHOW_CUSTOMER_PERMISSION': 'Müşteri Listesini Görüntüleme',
        'SHOW_ORDER_PERMISSION': 'İş Listesi Görüntüleme',
        'ADD_USER_PERMISSION': 'Kullanıcı Ekleme',
        'SHOW_FINANCE_PERMISSION': 'Finansal Raporlar',
        'SHOW_SETTING_PERMISSION': 'Ayarlar',
        'EXCEL_PERMISSION': 'Excele Aktarma',
        'CREATE_ORDER_PERMISSION': 'İş oluşturma',
        'CREATE_PRODUCT_PERMISSION': 'Ürün Ekle Kaldır',
        'COMPLETE_ROUTE_PERMISSION': 'Rota Tamamla',
        'DELETE_ROUTE_PERMISSION': 'Rota Sil',
        'ADD_WORKER_PERMISSION': 'Kurye ekleme',
        'ADD_CUSTOMER_PERMISSION': 'Müşteri Ekleme',

        'APP_SSTATUS': 'App Durumu',

        'PAUSE': 'Kapalı',
        'ONLINE': 'Online',
        'CLOSED': 'Kullanmıyor',

        'DASHBOARD': "Özet",
        'SUPPORT': 'Destek',
        'ORDER_SUPPORT': 'İş Destek Durumu',
        'RESOLVED': 'Çözüldü',
        'UNRESOLVED': 'Çözülemedi',
        'SUPPORT_STATUS': 'Destek Durumu',
        'LAST_LOG_DATE': 'Son Hareket Tarihi',
        'GK_SUCCESS_RATE': 'Lojimod Başarı Oranı',

        'İşIST_ID': 'İşIst Ent. No : ',

        'MAIN_MENU': 'Ana Menü',
        'SUPPLIERS': 'Tedarikçiler',
        'CHANGELOG': 'Güncellemeler',
        'ROUTE_TIME': 'Rota Süresi',
        'DISTRICT': 'İlçe'

    });

    $translateProvider.translations('en', {
        // login.html
        'LOGIN_TITLE': 'Login',
        'EMAIL_LOGIN_PLCHLDR': 'Your Email...',
        'PASS_LOGIN_PLCHLDR': 'Your Password...',
        'REMEMBER_ME': 'Remember Me',
        'LOGIN': 'Login',
        // forgot.html
        'FORGOT_PASS': 'Forgot Password',
        'PASS_RESET_TITLE': 'Reset Password',
        'PASS_RESET_CONTENT': 'Please enter the email address you use when logging in.',
        'RESET_PASS_BTN': 'Reset',
        // password.html
        'PASSWORD_TITLE': 'New Password',
        'PASS_REPEAT_PLCHLDR': 'Repeat Password...',
        'PASS_FORM_BTN': 'Reset',
        'MAP': 'Map',
        'ROUTES': 'Routes',
        'ORDERS': 'Jobs',
        'OFFERS': 'Offers',
        'PRODUCTS': 'Products',
        'SUPPORT': 'Support',
        'DRIVERS': 'Team',
        'EARNING': 'Payments',
        'PARTNERS': 'Customers',
        'INVOICES': 'Invoices',
        'STATIONS': 'Branches',
        'REPORTS': 'Reports',
        'SETTINGS': 'Settings',
        'LOGOUT': 'Logout',
        'BILLING': 'Invoices',
        'FEEDBACK': 'Feedback',
        'ACCOUNT_INACTIVE': 'Your account is not active.',
        'ACCOUNT_INCORRECT_INFO': 'Your information is incorrect.',
        'PARTNER': 'Customer',
        'SELECT_PARTNER': 'Select Customer',
        'SELECT_COMPANY': 'Select Supplier',
        'BY_COMPANY': 'By Supplier',
        'PARTNER_NAME': 'Customer Name',
        'PARTNER_DETAIL': 'Customer Details',
        'PARTNER_REPORT': 'Customer Reports',
        'NEW_PARTNER': 'New Customer',
        'PARTNER_NOT_FOUND': 'Customer Not Found',
        'ORDER_ID': 'Job No',
        'PRODUCT_DETAILS': 'Product Details',
        'FULL_NAME': 'Name',
        'PHONE': 'Phone Number',
        'STREET_ADDRESS': 'Street Address',
        'APARTMENT_BUILDIN': 'Building No, Apartment No',
        'SPECIAL_INST': 'Additional Notes',
        'DELIVERY_TYPE': 'Transportation Type',
        'DELIVERY_DATE': 'Transportation Date',
        'WEIGHT': 'Weight',
        'PIECE': 'Piece',
        'ADD_MORE': 'Add Package',
        'REMOVE_BOX': 'Remove Package',
        'IMPORT_ORDER_EXCEL': 'Upload Job via Excel',
        'FLEXIBLE_DATE': 'Flexible Date',
        'CITY': 'Province',
        'STATE': 'District',
        'SELECT_AREA': 'Select Region',
        'SELECT_STATE': 'Select District',
        'SELECT_CITY': 'Select Province',
        'SELECT_DISTRICTS': 'Select District',
        'ADD_DISTRICT': 'Add District',
        'REMOVE_DISTRICT': 'Remove',
        'CREATED_AT': 'Creation Date',
        'CREATED_ORDERS': 'Created Jobs',
        'CREATED': 'Created',
        'STARTED': 'Started',
        'CREATE': 'Create',
        'ORDER_CREATED_SUCCESS': 'Job created',
        'COMPLETED_AT': 'Delivery Date',
        'COMPLETED': 'Completed',
        'WAITING': 'Waiting',
        'NUMBER_OF_PIECE': 'Number of Packages',
        'ORDER_STATUS': 'Job Status',
        'NOTE_NOT_FOUND': 'Note Not Found',
        'WRITE_NOTE': 'Add Note',
        'NO_ACTIVITY': 'No Movement Found',
        'ROUTE_ACTIVITY': 'Route Movements',
        'ORDER_ACTIVITY': 'Job Movements',
        'ORDER_MOVE': 'Job Movement Center',
        'ACTIVITY': 'Movements',
        'NOTES': 'Notes',
        'NO_DETAILS': 'No Details Found',
        'DETAILS': 'Details',
        'ON_DELIVERY_ORDERS': 'Ongoing Jobs',
        'TOTAL_ORDERS': 'Total Jobs',
        'COMPLETED_ORDERS': 'Completed Jobs',
        'REFUND_ORDERS': 'Jobs Returned to Sender',
        'SHOW_COMPLETED_ORDERS': 'Show Completed Jobs',
        'UNSUCCESS_ORDERS': 'Unsuccessful Jobs',
        'CANCELLED_ORDERS': 'Cancelled Jobs',
        'DELIVERY_ORDERS': 'Delivery Jobs (Quantity)',
        'COLLECTION_ORDERS': 'Collection Jobs (Quantity)',
        'FAST_ORDERS': 'Fast Delivery',
        'DELIVERY_TIME': 'Delivery Date',
        'DELIVERY': 'Delivery Date',
        'NO_ORDERS': 'No Jobs Found',
        'NO_ROUTE': 'No Route Found',
        'NO_ORDER': 'No Job Found',
        'NO_INVOICE': 'No Invoice Found',
        'PRINT_ORDERS': 'Print',
        'ASSIGN_ORDERS_TO_CUSTOMER': 'Send Jobs to Customer',
        'ASSIGN_ORDERS_TO_ROUTE': 'Assign Jobs to Route',
        'ASSIGN_ORDERS_TO_WORKER': 'Assign Jobs to Courier',
        'CHANGE_BUlK_STATUS': 'Change Job Status',
        'ORDERS': 'Jobs',
        'APP_STATUS': 'App Status',
        'WORKER_LAST_ACTION': 'Courier Last Activity',
        'BY_WORKER': 'Search Courier',
        'ADD_ORDER': 'Add Job',
        'SAAS_COMPANY': 'Supplier',
        'CHANGE_PASSWORD': 'Change Password',
        'OLD_PASSWORD': 'Old Password',
        'NEW_PASSWORD': 'New Password',
        'COMPANY_INFO': 'Sender Information',
        'COMPANY_INFO_DESC': '* This number can be called with a masked number by customers.',
        'SUBJECT': 'Subject',
        'PRIORTY': 'Priority',
        'LOW': 'Low',
        'MIDDLE': 'Medium',
        'HIGH': 'High',
        'SEND': 'Send',
        'FEEDBACK_SUCCESSFULL_SEND': 'Your feedback has been received, thank you',
        'DRIVER_DETAIL': 'Courier Details',
        'VEHICLE_TYPE': 'Vehicle Type',
        'VEHICLE_YEAR': 'Vehicle Model Year',
        'VEHICLE_MAKE': 'Vehicle Model',
        'VEHICLE_MODEL': 'Vehicle Brand',
        'SELECT_VEHICLE': 'Select Vehicle',
        'VEHICLE_INFO': 'Vehicle Information',
        'VEHICLE': 'Vehicle',
        'STOPS': 'Number of Stops',
        'START_TIME': 'Start Time',
        'END_TIME': 'End Time',
        'TOTAL_TIME': 'Total Time',
        'SERVICE_TIME': 'Service Duration',
        'STOP_TIME': 'Service Duration',
        'TIME': 'Duration',
        'DISTANCE': 'Distance',
        'MILE': 'Km',
        'NOT_ASSIGNED': 'Not Assigned',
        'EDIT_ROUTES': 'Route Editing Mode',
        'CLOSE_EDIT_ROUTES': 'Close Editing Mode',
        'PLEASE_SELECT_ORDER': 'Please select a Job.',
        'PCS': 'Quantity',
        'DRIVER_NOT_FOUND': 'Courier Not Found',
        'SELECT_DRIVER': 'Select Courier',
        'DRIVER_REPORT': 'Courier Reports',
        'ADD_DRIVER': 'Add Courier',
        'ASSIGN_TO_DRIVER': 'Make Assignment',
        'ASSIGN': 'Make Assignment',
        'EDIT_DRIVER': 'Edit Courier',
        'NOTE_FROM_DRIVER': 'Courier Note',
        'DRIVER_INFO': 'Courier Information',
        'DRIVER': 'Courier',
        'ASSIGN_ORDER_RT': 'Assign Jobs to Route',
        'NOT_ASSIGN': 'Not Assigned',
        'SELECT_STATUS': 'Select Status',
        'CHANGE_STATUS': 'Change Status',
        'DELIVERY_STATUS': 'Delivery Status',
        'ROUTE_STATUS': 'Route Status',
        'CHANGE_ROUTE_STATUS': 'Change Route Status',
        'ARRIVED_STATUS': 'Arrival Status',
        'VERIFY_STATUS': 'Scanning Status',
        'STATUS': 'Status',

        'STATION': 'Branch',
        'SELECT_STATION': 'Select Branch',
        'EDIT_STATION': 'Edit Branch',
        'NEW_STATION': 'New Branch',
        'STATION_CODE': 'Branch Name',
        'STATION_NOT_FOUND': 'Branch Not Found',
        'STATION_LABEL': 'Branch No',
        'STATION_ADDRESS': 'Branch Address',
        // Filters
        'BY_STATION': 'By Branch',
        'BY_DRIVER': 'By Courier',
        'BY_CUSTOMER': 'By Recipient',
        'BY_PARTNER': 'By Customer Name',
        'BY_ORDER_ID': 'Job Number',
        'BY_ORDER_PAYMENT': 'Collection Type',
        'BY_DELIVERY_DATE': 'Transportation Date',
        'BY_STATUS': 'By Job Status',
        'BY_STATUS_NORMAL': 'Status',
        'BY_TYPE': 'By Job Type',
        'BY_ACTIVITY_TYPE': 'Movement Type',
        'BY_QR_CODE': 'QR Code',
        'BY_DATE': 'Date',
        'BY_PRICE': 'Price',
        'BY_INVOICE_ID': 'Invoice Number',
        'BY_NAME': 'Name',
        'CLEAR_FILTER': 'Clear Filter',
        'BY_RT_NUMBER': 'Route Number',
        'BY_CITY': 'By Province',
        'BY_DISTRICT': 'By District',
        'SEARCH_CONV': 'Search in Conversations',

        'ADDRESS_INFO': 'Address Information',
        'ADDRESS': 'Address',
        'TOTAL_ORDER': 'Total Jobs',
        'CUSTOMER_DBA': 'Brand Name',
        'AUTHORIZED_NAME': 'Authorized Name',
        'SEND_PUSH': 'Send Push Notification',
        'SEND_SMS': 'Send SMS',
        'SEND_MAIL': 'Send Mail',
        'SEND': 'Send',
        'DRAG_LOGO': 'Drag Logo',
        'DRAG_FILE': 'Drag File',
        'SELECT_FILE': 'Select File',
        'OR': 'Or',
        'SELECT_ALL': 'Select All',
        'SELECT_TYPE': 'Select Type',
        'SELECT_WEHICLE': 'Select Vehicle',
        'SELECT_STATIONS': 'Select Branches',
        'PLEASE_SELECT': 'Please Select',
        'SELECT': 'Select',
        'PHONE_NUMBER': 'Phone Number',
        'NUMBER_OF_PIECE': 'Number of Pieces',
        'NEW_ORDER': 'New Job',
        'NEW_ROUTE': 'New Route',
        'NEW_DRIVER': 'New Courier',
        'NEW_STATION': 'New Branch',
        'TOTAL_RECORD': 'Total Record',
        'PRINT': 'Print',
        'PRINT_PDF': 'Print as PDF',
        'EDIT': 'Edit',
        'NEW': 'Add New',
        'UPDATE': 'Update',
        'CANCEL': 'Cancel',
        'ARE_U_SURE_DELETE': 'Are you sure you want to delete?',
        'DELETE': 'Delete',
        'OKEY': 'Okay',
        'ACTION': 'Actions',
        'COMPANY_NAME': 'Sender Name',
        'ADDRESS': 'Address',
        'FILTER': 'Filter',
        'APPLY_FILTER': 'Apply Filter',
        'CLEAR_FILTER': 'Clear Filter',
        'EXCEL_EXPORT': 'Export',
        'COMPANY_TYPE': 'Sender Type',
        'CURRENT_PAGE': 'Page',
        'TOTAL_PAGE': 'Total Pages',
        'BACK': 'Back',
        'PREV': 'Next',
        'ADD': 'Add',
        'CREATE': 'Create',
        'TRANSACTIONS': 'Transactions',
        'CREATED_AT': 'Data Entry Date',
        'DETAILS': 'Details',
        'WARNING': 'Warning!',
        'CLOSE': 'Close',
        'CONTINUE': 'Continue',
        'WILL_YOU_CONTINUE': 'Do you want to continue?',
        'TODAY': 'Today',
        'YESTERDAY': 'Yesterday',
        'LAST_7_DAYS': 'Last 7 Days',
        'LAST_30_DAYS': 'Last 30 Days',
        'THIS_MONTH': 'This Month',
        'LAST_MONTH': 'Last Month',
        'CUSTOM_RANGE': 'Custom Range',
        'DONE': 'Done',
        'FROM': 'from',
        'TYPE': 'Type',
        'DELIVERED_BY': 'Delivered By',
        'DELIVERED_AT': 'Delivery Date',
        'DELIVERED_TO': 'Delivered To',
        'NOT_DELIVERED_TO': 'Reason for Non-Delivery',
        'NOT_DELIVERED_AT': 'Transaction Date',
        'SIGNATURE': 'Signature',
        'IMAGE': 'Image',
        'BY': 'By',
        'ROUTE_ID': 'Route ID',
        'EXPIRED_DATE': 'Expiration Date',
        'DATE': 'Date',
        'GO_TO_ORDER': 'Go to Job',
        'READ_ALL_PICKUP': 'All Picked Up',
        'RECEIVER': 'Recipient Customer',
        'EARNING_NOT_FOUND': 'Payment Not Found',
        'DONT_ACCOUNT': 'Don\'t have an account yet?',
        'GET_START': 'Register Now!',
        'BRAND': ' ',
        'ORDER_PAYMENT': 'Payment Type',
        'PRODUCT_ID': 'Product No',
        'SALE_COUNT': 'Sales Count',
        'PRICE_COUNT': 'Price Count',
        'NO_PRODUCT': 'No Product Found',
        'PRODUCT_PRICES': 'Prices',
        'PRICE': 'Price',
        'ADD_PRICE': 'Add Price',
        'REMOVE_PRICE': 'Remove Price',
        'PRODUCT_SAVED': 'Product Added',
        'PRODUCT_UPDATED': 'Product Updated',
        'PRODUCT_DELETED': 'Product Deleted',
        'NAME': 'Name',
        'DESCRIPTION': 'Description',
        'CREATE': 'Save',
        'PRICE_NOT_FOUND': 'Price Not Found',
        'PRODUCT_DETAIL': 'Product Details',
        'ID': 'No',
        'UNSELECT': 'Deselect',
        'MESSAGE': 'Message',
        'QTY': 'Quantity',
        'PAID': 'Paid Amount',
        'NOT_PAID': 'Pending',
        'BALANCE_DUE': 'Remaining Amount',
        'TOTAL_TIP': 'Total Tip',
        'TOTAL': 'Total',
        'INVOICE_DETAIL': 'Invoice Details',
        'INVOICE_ID': 'Invoice No',
        'NO_INVOICE': 'No Invoice Found',
        'INVOICE_REPORT': 'Invoice Reports',
        'MONEY_UNIT': '$',
        'OPEN': 'Open',
        'TAX': 'Tax',
        'PRICE_RATE': 'Price per Unit',
        'PAID_SUCCESS': 'Paid',
        'ADD_PAYMENT': 'Add Payment',
        'PAYMENTS': 'Payments',
        'DEBT': 'Debt',
        'CREDIT': 'Credit',
        'MY_PROFILE': 'My User Information',
        'USER_INFO': 'User Information',
        'FIRST_NAME': 'First Name',
        'LAST_NAME': 'Last Name',
        'PASSWORD': 'Password',
        'PERMISSION': 'Permissions',
        'USERS': 'Users',
        'ORDER_REPORT': 'Job Reports',
        'EARNING_REPORT': 'Courier Payment Reports',
        'NUMBER_OF_ROUTE': 'Number of Routes',
        'EARNING_DETAIL': 'Courier Payment Details',
        'EARNING_ID': 'Payment No',
        'STARTED_AT': 'Start Time',
        'ENDED_AT': 'End Time',
        'CUSTOMER_NAME': 'Customer Name',
        'PRICE_PER_ORDER': 'Price per Job',
        'MIN_WEIGHT': 'Min. Weight',
        'MAX_WEIGHT': 'Max. Weight',
        'PRICING': 'Pricing',
        'ADD_PRICE': 'Add Price',
        'REMOVE_PRICE': 'Remove Price',
        'STATION_DISTRICT_INFO': 'Select authorized districts for the branch',
        'ADD_DISTRICT': 'Add District',
        'DISTRICTS': 'Districts',
        'CODE': 'Code',
        'STATION_CREATED': 'Branch created.',
        'STATION_UPDATED': 'Branch updated.',
        'STATION_DELETED': 'Branch deleted.',
        'EXPORT_EXCEL': 'Export to Excel',
        'REPORTS': 'Reports',
        'REPORT': 'Report',
        'COMPANY_NAME': 'Sender Name',
        'DBA_INFO': '* Brand name will be used for SMS, Phone number will be used as Support Phone.',
        'COMPANY_INFO_UPDATED': 'Sender information updated',
        'PROOF': 'Delivery Information',
        'YES': 'Yes',
        'NO': 'No',
        'DISPATCHER': 'Dispatch Authority',
        'DISPATCH_STATIONS': 'Authorized Branches',
        'DEVICE': 'Device',
        'DOCUMENTS': 'Documents',
        'APPROVE': 'Approve',
        'REMOVE_APPROVE': 'Remove Approval',
        'SWITCH_ONLINE': 'Switch Online',
        'SWITCH_OFFLINE': 'Switch Offline',
        'WAIT_APPROVE': 'Waiting for Approval',
        'APPROVED': 'Approved',
        'DONE': 'Done',
        'PRICE_PER_ORDER': 'Price per Job',
        'NOTES': 'Notes',
        'DELIVERY_PAYMENT_TYPE': 'COD Shipment',
        'DELIVERY_PAYMENT_PRICE': 'Collection Amount',
        'AUTHORITY_STATIONS': 'Authorized Branches',
        'COLLECTION': 'COD Collection',
        'TOTAL_COLLECTION': 'Total COD',
        'KO': 'Payment Status',
        'KO_TYPE': 'Payment Type',
        'KO_PRICE': 'COD Amount',
        'KO_NO': 'Paid',
        'WORK_TYPE': 'Job Type',
        'NO_COLLECTION': 'No COD Collection Found',
        'PAYMENT_NOT_FOUND': 'Payment Not Found',
        'COLLECTION_REPORT': 'COD Reports',
        'BARCODE': 'Barcode',
        'WORKER': 'Courier',
        'ORDER_PRICE': 'Job Price',
        'SUPPLIER_PRICE': 'Supplier Price',
        'NO_NOTIFICATION': 'No Notification Found',
        'MOVEMENT_TYPE': 'Movement Type',
        'DOWNLOAD_VEHICLE': 'Download from Vehicle',
        'INSTALL_VEHICLE': 'Install to Vehicle',
        'LOAD_STATION': 'Load to Branch Line',
        'CHECK_ORDER': 'Confirm Scan',
        'ORDER_ID_OR_SPECIAL': 'Job No or Integrated Code',

        'PAYMENT_INFO': 'Payment Information',
        'ACCOUNT_HOLDER_NAME': 'Account Holder Name',
        'IBAN': 'IBAN',

        'ARE_YOU_SURE_DELETE': 'Are you sure you want to delete?',

        'ONLINE_PAYMENT_ORDER': 'Payment at Doorstep',
        'OFFLINE_PAYMENT_ORDER': 'Paid',

        'FINANCE': 'Finance',
        'TAX_NUMBER': 'Tax Number',
        'COMPANY_ADDRESS': 'Address',
        'COMPANY_DOCUMENT': 'Tax Plate',

        'DAILY_ROUTE_COUNT': 'Daily Route Count',
        'ROUTE_MOVE': 'Add Route Work',
        'ROUTE': 'Route',
        'SELECT_ROUTE': 'Select Route',
        'SPECIAL_TRACKING_NUMBER': 'Integration Code',
        'ORDER_SOURCE': 'Work Data Source',
        'SMS_EMAIL_PERMISSION': 'SMS-Email Permission',
        'SEND_SMS': 'Send SMS',
        'SEND_EMAIL': 'Send Email',
        'ALL_ORDERS': 'Passive Works',
        'NOTES_ORDERS': 'Noted Works',
        'ALL_REAL_ORDERS': 'Active Works',
        'BY_TERM': 'Search Work',
        'CARGO_DATE': 'Work Date',
        'SELECT_DATE_TYPE': 'Date Type',
        'SCHEDULED_TIME_TYPE': 'By Delivery Date',
        'SCHEDULED_TIME': 'Delivery Date',
        'CREATED_AT_TYPE': 'By Registration Date',
        'CARGO_DATE_TYPE': 'By Work Date',
        'COMPLETED_AT_TYPE': 'By Delivery Date',
        'CITY_STATE': 'Province-District',
        'INTEGRATION_NUMBER': 'Int. No:',
        'TRANSFER_NOT_FOUND': 'Transfer Center Not Found',
        'TRANSFER_CREATED': 'Transfer Center Created.',
        'TRANSFER_UPDATED': 'Transfer Center Updated.',
        'TRANSFER_DELETED': 'Transfer Center Deleted.',
        'BY_TRANSFER': 'Search Transfer Center',
        'NEW_TRANSFER': 'Add New',
        'NEW_TRANSFER': 'Add Transfer Center',
        'EDIT_TRANSFER': 'Edit Transfer Center Information',
        'TRANSFER_CENTERS': 'Transfer Centers',
        'SELECT_TRANSFER': 'Select Transfer Center',
        'TRANSFER': 'Transfer Center',

        'BY_SHIPMENT_AREA': 'Search Distribution Area',
        'NEW_SHIPMENT_AREA': 'New Distribution Area',
        'EDIT_SHIPMENT_AREA': 'Edit Distribution Area',
        'SHIPMENT_AREA': 'Distribution Areas',
        'SHIPMENT_AREA_NOT_FOUND': 'Distribution Area Not Found',
        'SHIPMENT_AREA_CREATED': 'Distribution Area Created.',
        'SHIPMENT_AREA_UPDATED': 'Distribution Area Updated.',
        'SHIPMENT_AREA_DELETED': 'Distribution Area Deleted.',

        'FAIL_ORDER': 'Undelivered Works',
        'NO_FAIL_ORDER': 'No Undelivered Work Found',
        'FAIL_ORDER_SAVED': 'Saved',
        'FAIL_ORDER_UPDATED': 'Updated',
        'FAIL_ORDER_DELETED': 'Deleted',
        'ORDER_COUNT': 'Work Count',
        'PRINT_STATUS': 'Printing Status',
        'RETURN_LIST': 'Return to List',
        'FAIL_ORDER_WARNING': 'Attention, there are Works with a status other than Not Completed in this list. Do you want to continue?',

        'TRANSFER_ORDER': 'Transferred Works',
        'TRANSFER_DATE': 'Transfer Date',
        'TRANSFER_WORKER': 'Transfer Courier',
        'TRANSFER_PCS': 'Transfer Work',

        'RETURN_ORDER': 'Returned Works',
        'RETURN_ORDER_ID': 'Returned Work',
        'NO_RETURN_ORDER': 'No Returned Work Found',
        'RETURN_ORDER_SAVED': 'Saved',
        'RETURN_ORDER_UPDATED': 'Updated',
        'RETURN_ORDER_DELETED': 'Deleted',
        'RETURN_ORDER_WARNING': 'Attention, there are Works with a status other than Not Completed in this list. Do you want to continue?',

        'WORKER_STATION': 'Courier Branch',
        'DOCUMENTS': 'Documents',
        'ADD_DOCUMENT': 'Add Document',
        'DOCUMENT_TYPE': 'Document Type',
        'DOCUMENT_NOT_FOUND': 'Document Not Found',
        'SHOW': 'Show',

        'DELETE_ORDER_PERMISSION': 'Delete Work',
        'SHOW_ROUTE_PERMISSION': 'View Route List',
        'SHOW_CUSTOMER_PERMISSION': 'View Customer List',
        'SHOW_ORDER_PERMISSION': 'View Work List',
        'ADD_USER_PERMISSION': 'Add User',
        'SHOW_FINANCE_PERMISSION': 'Financial Reports',
        'SHOW_SETTING_PERMISSION': 'Settings',
        'EXCEL_PERMISSION': 'Export to Excel',
        'CREATE_ORDER_PERMISSION': 'Create Work',
        'CREATE_PRODUCT_PERMISSION': 'Add Remove Product',
        'COMPLETE_ROUTE_PERMISSION': 'Complete Route',
        'DELETE_ROUTE_PERMISSION': 'Delete Route',
        'ADD_WORKER_PERMISSION': 'Add Courier',
        'ADD_CUSTOMER_PERMISSION': 'Add Customer',

        'APP_SSTATUS': 'App Status',

        'PAUSE': 'Closed',
        'ONLINE': 'Online',
        'CLOSED': 'Not Using',

        'DASHBOARD': "Summary",
        'SUPPORT': 'Support',
        'ORDER_SUPPORT': 'Work Support Status',
        'RESOLVED': 'Resolved',
        'UNRESOLVED': 'Unresolved',
        'SUPPORT_STATUS': 'Support Status',
        'LAST_LOG_DATE': 'Last Activity Date',
        'GK_SUCCESS_RATE': 'Lojimod Success Rate',

        'İşIST_ID': 'Lojimod Int. No:',

        'MAIN_MENU': 'Main Menu',
        'SUPPLIERS': 'Suppliers',
        'CHANGELOG': 'Changelog',
        'ROUTE_TIME': 'Route Time',
    });

    //$translateProvider.determinePreferredLanguage();
    $translateProvider.preferredLanguage(LANGUAGE);
    $translateProvider.useSanitizeValueStrategy('sce');
}]);